import { baseUrl, getTokenFromLocalStorage } from "./Configuration";

export interface IMoveOutReminder {
  id: string;
  listingId: string;
  reminder: number;
  isReminded: boolean;
  reminderType: string;
}

export interface ICreateMoveOutReminder {
  listingId: string;
  reminder: number;
  isReminded: boolean;
  reminderType: string;
}

export async function getMoveOutReminders(
  listingId: string
): Promise<IMoveOutReminder[]> {
  const url = `${baseUrl}/api/RentedReminder/${listingId}`;
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error("Failed to fetch move-out reminders:", response.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching move-out reminders:", error);
    return [];
  }
}

export async function createMoveOutReminder(
  reminder: ICreateMoveOutReminder
): Promise<boolean> {
  const url = `${baseUrl}/api/RentedReminder`;
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(reminder),
    });
    if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return false;
  }
    if (response.ok) {

      return true;
    } else {
      const errorText = await response.text();
      console.error(
        "Failed to create move-out reminder:",
        response.status,
        errorText
      );
      return false;
    }
  } catch (error) {
    console.error("Error creating move-out reminder:", error);
    return false;
  }
}

export async function deleteMoveOutReminder(id: string): Promise<boolean> {
  const url = `${baseUrl}/api/RentedReminder/${id}`;
  const token = await getTokenFromLocalStorage();
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers: headers,
    });
    if (response.status === 401) {
    localStorage.clear();
    window.location.href = "/login";
    return false;
  }
    if (response.ok) {
      return true;
    } else {
      const errorText = await response.text();
      console.error(
        "Failed to delete move-out reminder:",
        response.status,
        errorText
      );
      return false;
    }
  } catch (error) {
    console.error("Error deleting move-out reminder:", error);
    return false;
  }
}
